export function formatString(input: string | String) {
  if (!input) return input;

  return (
    input
      // Add space between lowercase and uppercase (bookingApproval)
      .replace(/([a-z])([A-Z])/g, "$1 $2")

      // Add space between multiple capitals followed by lowercase (XMLHttp → XML Http)
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")

      // Replace underscores with spaces
      .replace(/_/g, " ")

      // Capitalize each word properly
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
  );
}
